import axios from 'axios';
import { useState } from 'react';
import { showErrorToast, showSuccessToast } from '../utils/helpers';
import { Components } from '../utils/types';
import { API_BASE_URL, WBS_ELEMENT_BASE_URL } from './api';

export const usePushWBSElement = (element?: Components.Schemas.WBSElementDeltaDTO, deltaStructId?: string) => {
    const jwtObj = localStorage.getItem('auth');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(true);
    const [error, setError] = useState<string>();

    const push = async () => {
        if (element) {
            setLoading(true);
            setError(undefined);

            console.log('elem:', element, 'delta id: ', deltaStructId, !element.wbsElementDelta && deltaStructId);

            const url = `${API_BASE_URL}${WBS_ELEMENT_BASE_URL}/${element.id}/DeltaStructure/${deltaStructId}/Transfer`;

            // const url =
            //     !element.wbsElementDelta && deltaStructId
            //         ? `${API_BASE_URL}${WBS_ELEMENT_BASE_URL}/${element.id}/DeltaStructure/${deltaStructId}/Transfer`
            //         : `${API_BASE_URL}${WBS_ELEMENT_BASE_URL}/${element.id}/Delta/${element.wbsElementDelta?.id}/Transfer`;

            axios
                .put(url, {
                    headers: { Authorization: `Bearer ${jwtObj}` },
                })
                .then((res) => {
                    setSuccess(true);
                    setError(undefined);
                    showSuccessToast(`Element pushed successfully`);
                })
                .catch((e) => {
                    setError(String(e));
                    showErrorToast(`Error during push: ${e}`);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else showErrorToast(`Invalid WBS Element or Delta ID`);
    };

    return { push, loading, success, error };
};
